module.exports = __webpack_public_path__ + "media/images/logo-color-8c1b2a05581b4e9d4cbd51608766216a.svg";